// @auto-index

import _1 from './1.jpg'
import _2 from './2.jpg'
import _3 from './3.jpg'
import _4 from './4.jpg'
import _5 from './5.jpg'
import _6r1920x1080 from './6r1920x1080.jpg'
import _7r1920x1080 from './7r1920x1080.jpg'
import _8r1920x1080 from './8r1920x1080.jpg'

export { default as _1 } from './1.jpg'
export { default as _2 } from './2.jpg'
export { default as _3 } from './3.jpg'
export { default as _4 } from './4.jpg'
export { default as _5 } from './5.jpg'
export { default as _6r1920x1080 } from './6r1920x1080.jpg'
export { default as _7r1920x1080 } from './7r1920x1080.jpg'
export { default as _8r1920x1080 } from './8r1920x1080.jpg'

export default {
  _1,
  _2,
  _3,
  _4,
  _5,
  _6r1920x1080,
  _7r1920x1080,
  _8r1920x1080
}
